import moment from "moment";

function fechaValida(value) {
  if (typeof value !== "string" || !value.trim()) return null;
  const text = value.trim();
  for (const locale of [moment.locale(), "es", "en"]) {
    const date = moment(text, [moment.ISO_8601, "DD/MMM/YYYY", "DD/MM/YYYY"], locale, true);
    if (date.isValid()) return date;
  }
  return null;
}

// Comprobación final de los parámetros ya formateados, antes de enviar al API.
export function errorRangoFechasFiltro(filters, campoFecha) {
  const rango = filters && (campoFecha ? filters[campoFecha] : [filters.fechaDesde, filters.fechaHasta]);
  const completo = Array.isArray(rango) && rango.length === 2;
  const inicio = completo ? fechaValida(rango[0]) : null;
  const fin = completo ? fechaValida(rango[1]) : null;
  if (!inicio || !fin || fin.isBefore(inicio, "day")) {
    return { error: "Seleccione un rango de fechas completo y válido antes de consultar o exportar." };
  }
  return null;
}
